import script from "./Rating-Btn.vue?vue&type=script&setup=true&lang=js"
export * from "./Rating-Btn.vue?vue&type=script&setup=true&lang=js"

import "./Rating-Btn.vue?vue&type=style&index=0&id=5abee412&lang=css"

const __exports__ = script;

export default __exports__